export default {
  primary: 'Primary',
  spouse: 'Spouse',
  child: 'Child',
};
